export default __webpack_public_path__ + "static/media/favicon.9aac3b24.ico";